import { ObserversModule } from '@angular/cdk/observers'
import { ChangeDetectionStrategy, Component, input } from '@angular/core'

import { AiIconsModule } from '../../../../common/icons/ai-icons.module'

@Component({
  selector: 'flx-ai-preview-area-header',
  imports: [AiIconsModule, ObserversModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './preview-area-header.component.html',
})
export class AiPreviewAreaHeaderComponent {
  title = input('')
  hasInfoButton = input(false)

  // TODO: rewire to the AI builder harness
  draftInfo(): void {}
}
